export const initHomepageDialogReviewRequest = () => {
  const dialogReviewRequest = document.getElementById("dialog-review-request") as HTMLDialogElement;

  if (!dialogReviewRequest) {
    return;
  }

  const hostnameBase = window.location.hostname.replace(/^[^.]*./, "");

  // Add cookie to make sure dialog is only shown once per month
  // biome-ignore lint/suspicious/noDocumentCookie: <Refactor later>
  document.cookie =
    "dialog_review_request=true; max-age=2592000; path=/; domain=" +
    hostnameBase +
    "; secure; samesite=lax";
};
